export const DAY = 24 * 60 * 60 * 1000;
export const WEEK = 7 * DAY;
export const MONTH = 31 * DAY;
export const TOOLTIP_LABEL_FORMAT = 'MMM DD YYYY HH:mm:ss';
export const AXIS_COLOR = '#ccc';
export const LABEL_COLOR = '#000';
export const SPLIT_LINE_OPACITY = 0.4;

export const isDataOneMinGranular = diff => diff <= DAY;

export const getXAxisLabelFormat = (diff, liveMode = false) => {
  if(liveMode){
    return 'HH:mm:ss';
  }

  if (diff <= DAY) {
    return 'HH:mm';
  }
  if ((DAY < diff) && (diff <= WEEK)) {
    return 'ddd HH:mm';
  }
  if ((WEEK < diff) && (diff <= MONTH)) {
    return 'MMM DD';
  }
  return 'YYYY MMM DD';
};
